import { FaTwitch, FaTwitter, FaTiktok, FaYoutube, FaDiscord, FaHeart } from "react-icons/fa";
import "../App.css";

const links = [
  { name: "Twitch", url: "https://www.twitch.tv/luismd_", icon: <FaTwitch /> },
  { name: "Discord", url: "https://discord.gg/wxZ68rnT8N", icon: <FaDiscord /> },
  { name: "Twitter", url: "https://x.com/MDLuis_", icon: <FaTwitter /> },
  { name: "Tiktok", url: "https://www.tiktok.com/@luismd__", icon: <FaTiktok /> },
  { name: "YouTube", url: "https://www.youtube.com/@LuisMD_", icon: <FaYoutube /> },
  { name: "Donaciones", url: "https://streamlabs.com/luismd_/tip", icon: <FaHeart />}
];

const Home = () => {

  return (
    <div className="container">
      <div className="profile">
        <img src={"/natsu.jpg"} alt="Profile Pic" className="profile-img" />
        <h1>LuisMD</h1>
        <p>Hola</p>
      </div>
      <div className="links">
        {links.map((link, index) => (
          <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="link-a">
          <div  className="link-box">
            <span className="icon">{link.icon}</span>
            <span className="link-text">{link.name}</span>
          </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Home;